module.exports = __webpack_public_path__ + "img/index_huajiaji.eeaf2804.png";